<template>
  <div
    :class="[
      'ui-form-inner-button-icon',
      `ui-form-inner-button-icon--${size}`,
      `ui-form-inner-button-icon--${placement}`,
      containerClass,
    ]"
  >
    <slot />

    <button-icon
      v-show="!hide"
      v-bind="{ ...$props, ...$attrs }"
      class="ui-form-inner-button-icon__cta"
    />
  </div>
</template>

<style lang="sass">
.ui-form-inner-button-icon
  $self: &

  position: relative

  /// Necessary, due to the <ui-form-tree> or <ui-form-async-typeahead> using,
  /// with certain condition, z-index management
  &:focus-within &__cta
    z-index: z-index($z-indexes, 'main', 'ceil')

  &__cta
    position: absolute

  /// Placement + Sizing
  @each $pos in (left, right)

    &--#{$pos}

          &#{$self}--sm
            $x-padding: 42px
            $x-offset: 10.5px
            $font-size: $icon-default-size - 10px

            .ui-form-input,
            .ui-form-async-typeahead .autocomplete-input,
            .ui-form-date-single input.form-control,
            .ui-form-date-multiple input.form-control
              padding-#{$pos}: $x-padding

            .ui-form-tree.ui-form-tree-clearable.vue3-treeselect--has-value .vue3-treeselect__control
              $x-padding-tree-empirical-fix: 32px

              padding-#{$pos}: $x-padding-tree-empirical-fix

            #{$self}__cta
              font-size: $font-size
              top: 50%
              transform: translateY(-50%)
              #{$pos}: $x-offset

          &#{$self}--md
            $x-padding: 42px
            $x-offset: 10.5px
            $font-size: $icon-default-size - 7px

            .ui-form-input,
            .ui-form-async-typeahead .autocomplete-input,
            .ui-form-date-single input.form-control,
            .ui-form-date-multiple input.form-control
              padding-#{$pos}: $x-padding

            .ui-form-tree.ui-form-tree-clearable.vue3-treeselect--has-value .vue3-treeselect__control
              $x-padding-tree-empirical-fix: 32px

              padding-#{$pos}: $x-padding-tree-empirical-fix

            #{$self}__cta
              font-size: $font-size
              top: 50%
              transform: translateY(-50%)
              #{$pos}: $x-offset

          &#{$self}--lg
            $x-padding: 42px
            $top-offset: 13px
            $x-offset: 13px
            $font-size: $icon-default-size - 2px

            .ui-form-input,
            .ui-form-async-typeahead .autocomplete-input,
            .ui-form-date-single input.form-control,
            .ui-form-date-multiple input.form-control
              padding-#{$pos}: $x-padding

            .ui-form-tree.ui-form-tree-clearable.vue3-treeselect--has-value .vue3-treeselect__control
              $x-padding-tree-empirical-fix: 32px

              padding-#{$pos}: $x-padding-tree-empirical-fix

            #{$self}__cta
              font-size: $font-size
              top: 50%
              transform: translateY(-50%)
              #{$pos}: $x-offset

</style>

<script lang="ts">
import type { SlotsType } from 'vue'
import ButtonIcon, { ButtonIconProps } from '../ButtonIcon.vue'

export const InnerButtonIconProps = {
  placement: {
    type: String as PropType<"left"|"right">,
    required: false,
    default: 'right'
  },
  containerClass: {
    type: String,
    required: false,
    default: ''
  },
  hide: {
    type: Boolean,
    required: false,
    default: false,
  },
  ...ButtonIconProps
} as const

export default defineComponent({
  components: { ButtonIcon },
  inheritAttrs: false,
  props: {
    ...InnerButtonIconProps
  },
  slots: Object as SlotsType<{
    'default': {},
  }>,
})
</script>
